import * as React from 'react';
import templates from '../../data/templates';

interface KiteMetaProps {
    templateKey: keyof typeof templates;
}

export default function KiteMeta({ templateKey }: KiteMetaProps) {
    const meta = templates[templateKey].meta;

    return (
        <>
            {Object.entries(meta).map(([dt, dd]) => (
                <dl key={dt} className={dt}>
                    <dt>{dt}</dt>
                    <dd>
                        {(dt === 'buildPlans' ||
                            dt === 'manufacturerContact') &&
                        dd !== 'tbd' ? (
                            <a href={dd} target="_blank">
                                {dd}
                            </a>
                        ) : (
                            dd
                        )}
                    </dd>
                </dl>
            ))}
        </>
    );
}
